import { createApiMutation, createApiQuery } from '@/features/api'

import type { AccountFormDto } from './components/account-form'
import type { IAccount } from './type'

export const ACCOUNT_KEY = {
	ME: '/account/me',
	ME_UPDATE: '/account/me/update',

	// MASTER
	MASTER_LIST: '/account/management/list',
	MASTER_DETAIL: '/account/management/detail',
	MASTER_CREATE: '/account/management/create',
	MASTER_UPDATE: '/account/management/update',
}

/* ----------------------------------- API ---------------------------------- */

// Account Me
export const accountMe = createApiQuery(ACCOUNT_KEY.ME)

// Account Master - List
export const accountMasterList = createApiQuery<{
	result: { accounts: IAccount[]; total: number }
}>(ACCOUNT_KEY.MASTER_LIST)

// Account Master - Details
export const accountMasterDetail = createApiQuery<{
	params: { id: string }
	result: { account: IAccount }
}>(ACCOUNT_KEY.MASTER_DETAIL)

// Account Master - Create
export const accountMasterCreate = createApiMutation<{
	body: AccountFormDto
}>(ACCOUNT_KEY.MASTER_CREATE, { method: 'post' })

// Account Master - Update
export const accountMasterUpdate = createApiMutation<{
	params: { id: string }
	body: AccountFormDto & { id: string }
}>(ACCOUNT_KEY.MASTER_UPDATE, { method: 'put' })

/* ---------------------------------- STAFF --------------------------------- */

export const accountStaffList = createApiQuery<{
	params: { oId: string }
	result: { accounts: IAccount[]; total: number }
}>('/account/staff/list')

export const accountStaffAdd = createApiMutation<{
	body: { oId: string; accountIds: string[]; teamId: string }
}>('/account/staff/add', { method: 'post' })

export const accountStaffDelete = createApiMutation<{
	body: { oId: string; accountIds: string[] }
}>('/account/staff/remove', { method: 'delete' })
